import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';
import { theme } from './vuetify';

const options = {
  color: '#ffffff',
  failedColor: theme.error,
  thickness: '3px',
};

Vue.use(VueProgressBar, options);
